export default __webpack_public_path__ + "static/media/genosha.427b9cd8.png";